import { useEffect, useState } from "react";
import { ClipboardList, PenLine, FileText, ShoppingCart, Pause, Play, MessageCircle, CalendarDays, Bell, Sparkles } from "lucide-react";
import { DEMO_VIDEO_URL } from "@/lib/brand";

const SCENE = [
  { icon: ClipboardList, titolo: "Scheda di lavoro", testo: "Cliente, bici, lavori e ricambi: il totale si calcola da solo.", vantaggio: "Niente più calcoli a mano né schede perse",
    righe: [["Revisione completa", "45,00 €"], ["Catena Shimano HG-601", "32,00 €"], ["Pastiglie freno", "18,00 €"]], totale: "95,00 €" },
  { icon: PenLine, titolo: "Firma sul tablet", testo: "Privacy, contratti e preventivi firmati dal cliente sullo schermo.", vantaggio: "Zero carta, tutto archiviato nella scheda cliente", firma: true },
  { icon: FileText, titolo: "Preventivo su WhatsApp", testo: "Il PDF del preventivo arriva al cliente con un tocco.", vantaggio: "Il cliente approva prima, tu lavori senza sorprese", chat: ["Preventivo-2026-0042.pdf", "Ecco il preventivo per la sua bici. Totale 180,00 €", "Perfetto, procediamo!"] },
  { icon: MessageCircle, titolo: "Avviso bici pronta", testo: "Lavoro completato? Il messaggio al cliente è già scritto.", vantaggio: "Meno telefonate, ritiri più veloci", chat: ["VLR BIKE", "Buongiorno Mario, la sua bici è pronta. Totale 95,00 €. Può passare quando vuole!", "Grazie, arrivo alle 18!"] },
  { icon: Bell, titolo: "Promemoria tagliando", testo: "Vedi chi non passa in officina da 6 mesi e lo ricontatti.", vantaggio: "Clienti che tornano, officina sempre piena",
    righe: [["Giulia Bianchi · MTB Trek", "7 mesi"], ["Luca Verdi · Gravel Bianchi", "9 mesi"], ["Anna Neri · E-bike Haibike", "6 mesi"]], totale: "3 da contattare" },
  { icon: CalendarDays, titolo: "Agenda e flotta noleggio", testo: "Appuntamenti del giorno e bici libere o noleggiate a colpo d'occhio.", vantaggio: "Nessuna doppia prenotazione", flotta: true },
  { icon: ShoppingCart, titolo: "Cassa veloce", testo: "Vendi prodotti e ricambi, il magazzino si aggiorna in automatico.", vantaggio: "Incassi del giorno e scorte sempre sotto controllo",
    righe: [["Camera d'aria 29\"", "8,50 €"], ["Borraccia", "12,00 €"]], totale: "20,50 €" },
];

const Righe = ({ s }) => (
  <div className="space-y-2">
    {s.righe.map(([a, b]) => (
      <div key={a} className="demo-row flex justify-between rounded bg-slate-50 px-3 py-2 text-xs sm:text-sm"><span>{a}</span><span className="font-semibold">{b}</span></div>
    ))}
    <div className="flex justify-between border-t border-slate-200 pt-3 font-heading font-extrabold text-slate-900"><span>Totale</span><span className="text-orange-600">{s.totale}</span></div>
  </div>
);

const Firma = () => (
  <div className="rounded-md border-2 border-dashed border-slate-300 bg-white p-4">
    <svg viewBox="0 0 300 90" className="h-20 w-full"><path className="demo-sign" d="M10 60 C 40 10, 60 90, 90 45 S 140 20, 160 55 S 210 80, 230 35 S 270 40, 290 50" fill="none" stroke="#0f172a" strokeWidth="3" strokeLinecap="round" /></svg>
    <p className="mt-2 text-center text-xs text-slate-500">Firma del cliente · Mario Rossi</p>
  </div>
);

const Chat = ({ m }) => (
  <div className="space-y-2 rounded-md bg-[#e7ddd3] p-4">
    <div className="demo-row ml-auto w-4/5 rounded-lg bg-[#d9fdd3] p-3 text-xs shadow-sm"><p className="font-semibold">{m[0]}</p><p className="text-slate-600">{m[1]}</p></div>
    <div className="demo-row w-3/5 rounded-lg bg-white p-3 text-xs shadow-sm" style={{ animationDelay: "0.8s" }}>{m[2]}</div>
  </div>
);

const GIORNI = ["Lu", "Ma", "Me", "Gi", "Ve", "Sa", "Do"];
const FLOTTA = [["E-bike 01", [0, 0, 1, 1, 1, 0, 0]], ["E-bike 02", [1, 1, 0, 0, 0, 1, 1]], ["City 03", [0, 0, 0, 1, 1, 1, 0]]];

const Flotta = () => (
  <div className="space-y-1.5 text-[11px] sm:text-xs">
    <div className="grid grid-cols-[70px_repeat(7,1fr)] gap-1 text-center font-semibold text-slate-500"><span />{GIORNI.map((g) => <span key={g}>{g}</span>)}</div>
    {FLOTTA.map(([n, d]) => (
      <div key={n} className="demo-row grid grid-cols-[70px_repeat(7,1fr)] gap-1">
        <span className="truncate font-semibold text-slate-700">{n}</span>
        {d.map((v, k) => <span key={k} className={`h-6 rounded ${v ? "bg-orange-500" : "bg-emerald-100"}`} />)}
      </div>
    ))}
    <p className="pt-2 text-slate-500"><span className="mr-1 inline-block h-2 w-2 rounded-sm bg-emerald-200" />libera <span className="ml-3 mr-1 inline-block h-2 w-2 rounded-sm bg-orange-500" />noleggiata</p>
  </div>
);

const Scena = ({ s }) => {
  if (s.righe) { return <Righe s={s} />; }
  if (s.firma) { return <Firma />; }
  if (s.flotta) { return <Flotta />; }
  return <Chat m={s.chat} />;
};

export const DemoTour = () => {
  const [i, setI] = useState(0);
  const [play, setPlay] = useState(true);
  useEffect(() => {
    if (!play) { return undefined; }
    const t = setInterval(() => setI((v) => (v + 1) % SCENE.length), 4000);
    return () => clearInterval(t);
  }, [play]);

  if (DEMO_VIDEO_URL) {
    return <iframe data-testid="demo-video" src={DEMO_VIDEO_URL} title="Video demo" className="aspect-video w-full rounded-xl border-0 shadow-2xl" allowFullScreen />;
  }
  const s = SCENE[i];
  return (
    <div className="overflow-hidden rounded-xl bg-white shadow-2xl ring-1 ring-slate-900/10" data-testid="demo-tour">
      <div className="flex items-center gap-1.5 border-b border-slate-200 bg-slate-100 px-4 py-2.5">
        <span className="h-2.5 w-2.5 rounded-full bg-rose-400" /><span className="h-2.5 w-2.5 rounded-full bg-amber-400" /><span className="h-2.5 w-2.5 rounded-full bg-emerald-400" />
        <button data-testid="demo-play-toggle" onClick={() => setPlay(!play)} className="ml-auto rounded p-1 text-slate-500 hover:bg-slate-200" aria-label="Pausa o riproduci">{play ? <Pause className="h-3.5 w-3.5" /> : <Play className="h-3.5 w-3.5" />}</button>
      </div>
      <div key={i} className="grid min-h-[300px] gap-6 p-6 sm:grid-cols-[1fr_1.3fr] sm:p-8 fade-up">
        <div>
          <s.icon className="mb-4 h-8 w-8 text-orange-600" />
          <h3 className="font-heading text-xl font-extrabold text-slate-900" data-testid="demo-scene-title">{s.titolo}</h3>
          <p className="mt-2 text-sm text-slate-600">{s.testo}</p>
          <p className="mt-5 inline-flex items-center gap-2 rounded-full bg-orange-50 px-3 py-1.5 text-xs font-semibold text-orange-700" data-testid="demo-scene-vantaggio"><Sparkles className="h-3.5 w-3.5" />{s.vantaggio}</p>
        </div>
        <div><Scena s={s} /></div>
      </div>
      <div className="flex gap-1.5 px-6 pb-5">
        {SCENE.map((x, k) => (
          <button key={x.titolo} data-testid={`demo-step-${k}`} onClick={() => { setI(k); setPlay(false); }} className="h-1.5 flex-1 overflow-hidden rounded-full bg-slate-200" aria-label={x.titolo}>
            <span className={`block h-full bg-orange-600 ${k === i && play ? "demo-progress" : k <= i ? "w-full" : "w-0"}`} />
          </button>
        ))}
      </div>
    </div>
  );
};
